// @ts-strict-ignore
import {Directive, Input, TemplateRef, ViewContainerRef} from "@angular/core";

class VarContext<T = unknown> {
	public $implicit: T = null;
	public ngVar: T = null;
}

/**
 * @deprecated use the native @let syntax instead
 */
@Directive({
	selector: "[ngVar]",
	standalone: false,
})
export class VarDirective<T = unknown> {
	private _context: VarContext<T> = new VarContext<T>();

	private hasView: boolean = false;

	@Input()
	set ngVar(context: T) {
		this._context.$implicit = this._context.ngVar = context;

		if (!this.hasView) {
			this.vcRef.createEmbeddedView(this.templateRef, this._context);
			this.hasView = true;
		}
	}

	constructor(
		private templateRef: TemplateRef<VarContext<T>>,
		private vcRef: ViewContainerRef,
	) {}

	/**
	 * Asserts the correct type of the context for the template that `NgVar` will render.
	 *
	 * The presence of this method is a signal to the Ivy template type-check compiler that the
	 * `NgVar` structural directive renders its template with a specific context type.
	 */
	static ngTemplateContextGuard<T>(dir: VarDirective<T>, ctx: any): ctx is VarContext<Exclude<T, false | 0 | "" | null | undefined>> {
		return true;
	}
}
